'use client';

import {useEffect} from "react";

interface Props {
    content: string;
}

export default function WithInsta({content}: Props){
    useEffect(() => {
        /**
         * Charger le script twitter pour afficher les tweets
         */
        const script = document.createElement('script');

        script.src = 'https://platform.instagram.com/en_US/embeds.js';
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [content]);

    return (<></>)
}


